<template>
  <section>
    <div class="d-flex">
      <div class="pr-07">
        <b-icon variant="primary" icon="credit-card" scale="1.5" ></b-icon>
      </div>
      <div>
        <h1 class="h3 text-primary font--primary">
          <span>{{ headData.clientName }}</span>  
        </h1>
        <h2 class="h5 text-warning font--secondary"><span>{{ headData.subStatusName }}</span></h2>
      </div>
      <color-label v-if="isModal" :colorId="ticket.color_id" :ticketId="ticket.id" :colorArray="colorArray" :isModal="isModal"></color-label>
      <b-button variant="link" v-b-tooltip.hover title="OT y Referencia" @click="goToTicket()" class="font--secondary">
        <feather-icon icon="SendIcon"/> OT:
        {{ headData.trackingNumber}} <br> / Ref:
        {{ headData.importedId }}
      </b-button>
    </div>
  </section>
</template>
<script>
import colorLabel from '@/views/modules/tickets/components/List/colorLabel.vue'
import {
  BIcon,
  BIconCreditCard
} from 'bootstrap-vue'
/* eslint-disable vue/no-unused-components */
export default {
  props: ['ticket', 'masterData', 'colorArray', 'isModal'],
  components: {BIcon, BIconCreditCard, colorLabel},
  data() {
    return {
    }
  },
  computed: {
    dataUser() {
      return this.$session.get('cas_user')
    },
    headData() {
      return { 
        trackingNumber: this.ticket?.delivery?.tracking_number || 'Sin información',
        importedId: this.ticket?.delivery?.imported_id || 'Sin información',
        clientName: !!this.ticket && !!this.ticket?.current_status?.clientName ? this.ticket?.current_status?.clientName : '',
        subStatusName: !!this.ticket && !!this.ticket?.current_status?.sub_status_name ? this.ticket?.current_status?.sub_status_name : ''
      }
    }
  },
  mounted() {
  },
  methods: {
    goToTicket() {
      if (this.isModal) window.open(`https://app.enviame.io/tickets/${this.ticket.id}`, '_blank')
    }
  }
}
</script>